import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import SEO from '../../components/SEO';
import BlobMaskMorpher from '../../components/BlobMaskMorpher';
import NavExpander from '../../containers/NavExpander';
import styles from './inspiration-nation.css';

const InspirationNationColumn = ({ posts }) => {
  const durations = posts.map(() => (Math.floor(Math.random() * Math.floor(4)) + 1) * 4500);

  return (
    <div>
      <SEO title="Inspiration Nation: Critic's Corner" path="/inspiration-nation" />
      <NavExpander>
        <section className={styles.wrapper}>
          <div className={styles.content}>
            <ul className={styles.list}>
              {posts.map((item, i) => (
                <li key={item.title} className={styles.listItem}>
                  <NavLink className={styles.link} to={item.path}>
                    <div className={styles.scribbleHover} />

                    <div className={styles.row}>
                      <div className={styles.left}>
                        <h2 className={styles.title}>{item.title}</h2>
                        <p
                          className={styles.summary}
                          dangerouslySetInnerHTML={{ __html: item.excerpt }}
                        />
                      </div>
                      {item.image && (
                        <div className={styles.right}>
                          <div
                            className="svg-mask"
                            style={{
                              clipPath: `url(#blobMask${i})`,
                              WebkitClipPath: `url(#blobMask${i})`,
                              backfaceVisibility: 'hidden',
                              WebkitBackfaceVisibility: 'hidden',
                            }}>
                            <img className={styles.image} src={item.image} alt="" />
                          </div>
                          <BlobMaskMorpher duration={durations[i]} blobNum={i} />
                        </div>
                      )}
                    </div>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </NavExpander>
    </div>
  );
};

InspirationNationColumn.propTypes = {
  posts: PropTypes.array,
};

export default InspirationNationColumn;
